export { default } from "./ERC721Gated"
